import { createSelector } from 'reselect'


const getIsNewSubscribeFlowEnabled = createSelector(
  (state: ReduxState): number => state.models.me.balance,
  (state: ReduxState): boolean => state.models.me.isLoggedIn,
  (state: ReduxState): boolean => state.models.cart.areProductsExist,
  (state: ReduxState): boolean => state.models.subscription.isSubscribed,
  (balance, isLoggedIn, areProductsExist, isSubscribed) => (
    isLoggedIn
    && !balance
    && !isSubscribed
    && !areProductsExist
  )
)

export default getIsNewSubscribeFlowEnabled
